import { Injectable } from '@angular/core';
import { DateFormatService } from '@app/core/date/date-format.service';
import { CStorageKeys } from '@app/core/storage/storage-keys.const';
import { StorageService } from '@roller/rdl/utilities/storage';

@Injectable({
  providedIn: 'root'
})
export class AbTestingService {
  clientRandomized: IRandomClientDemographic | undefined;
  constructor(
    private storageService: StorageService,
    private dateFormatService: DateFormatService
  ) {}

  initAbTesting(): void {
    this.clientRandomized = this.setClientRandomized();
  }

  private setClientRandomized(): IRandomClientDemographic {
    let coldClientRandom = this.storageService.getItem<IRandomClientDemographic>(CStorageKeys.abTesting, true);
    if (!coldClientRandom || typeof coldClientRandom === 'string' || !this.isFresh(coldClientRandom)) {
      coldClientRandom = this.createRandomNumberDemographic();
      this.storageService.setItem(CStorageKeys.abTesting, JSON.stringify(coldClientRandom));
    }

    return coldClientRandom;
  }

  /** Creates a local stored variable that consistently locks the guest into A or B group - valid for 30 days */
  private createRandomNumberDemographic(): IRandomClientDemographic {
    return {
      expiry: this.dateFormatService.addDays(new Date(), 30),
      randomNumber: Math.random()
    };
  }

  private isFresh(clientRandom: IRandomClientDemographic): boolean {
    try {
      return new Date(clientRandom.expiry).getTime() > new Date().getTime();
    } catch (error) {
      return false;
    }
  }

  /** Random number's above 0.5 are consistently shown any experiments */
  isShownExperiment(): boolean {
    return this.clientRandomized ? this.clientRandomized?.randomNumber > 0.5 : false;
  }
}

interface IRandomClientDemographic {
  expiry: Date;
  randomNumber: number;
}
